import { QueryResources, QueryResourcesInfinite } from 'datx-jsonapi-react';

import { EventTicket } from '@/resources/EventTicket';

export const queryEventTicketForUser = (eventId: string, userId: string): QueryResources<EventTicket> => {
  if (!eventId || !userId) return null;
  return [
    EventTicket,
    {
      filter: {
        event_id: eventId,
        user_id: userId,
      },
    },
  ];
};

export const queryAllUserEvents = (userId: string): QueryResourcesInfinite<EventTicket> => {
  return (pageIndex, previousPageData) => {
    if (previousPageData && !previousPageData?.links?.next) {
      return null;
    }
    const pageNumber = pageIndex + 1;

    return [
      EventTicket.type,
      {
        filter: {
          user_id: userId,
        },
        sort: 'event_starts_at',
        include: ['event'],
        params: [
          {
            key: 'page[size]',
            value: '9',
          },
          {
            key: 'page[number]',
            value: pageNumber.toString(),
          },
        ],
      },
    ];
  };
};

export const queryAllEventTickets = (eventId: string): QueryResourcesInfinite<EventTicket> => {
  return (pageIndex, previousPageData) => {
    if (previousPageData && !previousPageData?.links?.next) {
      return null;
    }
    const pageNumber = pageIndex + 1;

    return [
      EventTicket.type,
      {
        filter: {
          event_id: eventId,
        },
        sort: 'event_starts_at',
        include: ['user'],
        params: [
          {
            key: 'page[size]',
            value: '9',
          },
          {
            key: 'page[number]',
            value: pageNumber.toString(),
          },
        ],
      },
    ];
  };
};
